import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, Transition as _Transition, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "modal-wrapper" }
const _hoisted_2 = { class: "modal-header" }
const _hoisted_3 = { class: "modal-title" }
const _hoisted_4 = {
  key: 0,
  class: "small"
}
const _hoisted_5 = {
  key: 1,
  class: "small"
}
const _hoisted_6 = { class: "modal-body" }
const _hoisted_7 = { class: "menu-option" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = ["onClick"]
const _hoisted_10 = {
  key: 0,
  class: "textarea-wr"
}
const _hoisted_11 = { class: "input--wrapper" }
const _hoisted_12 = { class: "controls" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock($setup["Modal"], {
    isOpen: $setup.props.isOpen,
    onClose: $setup.onClose,
    showClose: ""
  }, {
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, _toDisplayString($setup.props.modalTitle ? $setup.props.modalTitle : "Give a reason"), 1),
          ($setup.props.sendReasonToLead)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, "This reason will be sent to the lead via email."))
            : (_openBlock(), _createElementBlock("div", _hoisted_5, "This will be used for internal reporting purposes only. Your selection will not be shared with the purchaser."))
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode($setup["DropDown"], {
            class: _normalizeClass(["dropdown", { 'other-reason-selected': $setup.selectedReason === $setup.OTHER_REASON }])
          }, {
            control: _withCtx(() => [
              _createElementVNode("label", {
                class: _normalizeClass(["dropdown-button", { selected: $setup.selectedReason }])
              }, _toDisplayString($setup.selectedReason ? $setup.selectedReason : "Select a reason"), 3)
            ]),
            dropdown: _withCtx(() => [
              _createElementVNode("ul", _hoisted_7, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.props.reasons, (reason) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: reason,
                    onClick: ($event: any) => ($setup.selectedReason = reason)
                  }, [
                    _createElementVNode("div", {
                      class: "menu-item",
                      onClick: ($event: any) => ($setup.selectedReason = reason)
                    }, _toDisplayString(reason), 9, _hoisted_9)
                  ], 8, _hoisted_8))
                }), 128))
              ])
            ]),
            _: 1
          }, 8, ["class"]),
          _createVNode(_Transition, { name: "fade" }, {
            default: _withCtx(() => [
              ($setup.selectedReason === $setup.OTHER_REASON)
                ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                    _cache[2] || (_cache[2] = _createElementVNode("div", { class: "label" }, "Add comments:", -1)),
                    _createElementVNode("div", _hoisted_11, [
                      _withDirectives(_createElementVNode("textarea", {
                        class: "textarea",
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.otherReasonUserInput) = $event))
                      }, null, 512), [
                        [_vModelText, $setup.otherReasonUserInput]
                      ]),
                      _cache[1] || (_cache[1] = _createElementVNode("span", null, "Max length 50 words", -1))
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_12, [
            ($setup.props.canSkip)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: "button default",
                  onClick: $setup.onSkip
                }, "Skip"))
              : (_openBlock(), _createElementBlock("button", {
                  key: 1,
                  class: "button default",
                  onClick: $setup.onClose
                }, "Cancel")),
            _createElementVNode("button", {
              class: "button default primary",
              onClick: $setup.submit
            }, "Submit")
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["isOpen"]))
}